import type { Book, ScheduledBook } from "@book-club/shared";
import { isScheduledBook } from "@book-club/shared";
import { format } from "date-fns";

/**
 * Formats the month/year when a book was featured
 * @param book - Book or ScheduledBook
 * @returns Formatted string like "Nov 2025" or null if not scheduled
 */
export function getBookFeaturedDate(book: Book | ScheduledBook): string | null {
    if (!isScheduledBook(book)) {
        return null;
    }

    if (!book.month || !book.year) {
        return null;
    }

    return format(new Date(book.year, book.month - 1, 1), "MMM yyyy");
}

/**
 * Calculates average rating for a book
 * @param book - Book or ScheduledBook
 * @returns Average rating (0-5) or null if no ratings
 */
export function getBookAverageRating(book: Book | ScheduledBook): number | null {
    if (!isScheduledBook(book)) {
        return null;
    }

    if (book.ratingCount === 0 || !book.ratingCount) {
        return null;
    }

    return book.ratingSum / book.ratingCount;
}

/**
 * Formats rating for display
 * @param rating - Average rating (0-5) or null
 * @returns Formatted string like "4.5 ⭐" or "No ratings"
 */
export function formatBookRating(rating: number | null): string {
    if (rating === null) {
        return "No ratings";
    }

    return `${rating.toFixed(1)} ⭐`;
}
